export default "__VITE_ASSET__BRlf7ELR__"